/* eslint-disable no-unused-vars */
import React, { useRef } from 'react'
import {
  Box,
  Chip,
  Divider,
  Typography,
  Button,
  TextField
} from '@mui/material'
import { selectionButtonStyles } from '../../styles/classes/GeneralClasses'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-thin-svg-icons'
import { useTranslation } from 'react-i18next'

const selectionComponent = ({
  label,
  variant,
  selectionOptions,
  onAddSelection,
  onRemoveSelection,
  onChangeOptionText,
  selectedMoreThanOne,
  disableItems
}) => {
  const { classes } = selectionButtonStyles()
  const { t } = useTranslation()
  const inputList = selectionOptions ?? []

  const selectionItem = (option, idx) => {
    return (
      <Box
        className={classes.inputContainer}
        key={'selectionInputBox' + (idx + 1)}
      >
        <Box className={classes.titleContainer}>
          <Typography className={classes.titleFontStyle}>
            <Typography className={classes.titleSymbol}>*</Typography>
            {t('form_builder.elements.selection') + ' ' + (idx + 1)}
          </Typography>
          {inputList.length > 1 && (
            <Button
              disabled={disableItems}
              variant="text"
              className={classes.removeIconsButton}
              onClick={() => {
                onRemoveSelection(idx)
              }}
            >
              <FontAwesomeIcon
                className={classes.removeIcons}
                icon={faCircleXmark}
                size="xs"
              />
            </Button>
          )}
        </Box>
        <TextField
          disabled={disableItems}
          error={selectedMoreThanOne && option === ''}
          value={option}
          onChange={event => {
            onChangeOptionText(event, idx)
          }}
          required
          multiline
          className={classes.textField}
          variant={'outlined'}
          placeholder={t('form_builder.elements.selection_input_placeholder')}
          id={'selectionInput' + (idx + 1)}
          rows={4}
        />
      </Box>
    )
  }

  const scrollCheck = useRef(null)
  const handleOnClick = () => {
    onAddSelection()
    scrollCheck.current.scrollIntoView({ behavior: 'smooth' })
  }
  return (
    <Box className={classes.box}>
      <Divider className={classes.divider}></Divider>
      <Box>
        <Chip
          disabled={disableItems}
          className={classes.button}
          label={label}
          variant={variant}
          onClick={handleOnClick}
        />
      </Box>

      <Box
        className={
          inputList.length > 0 ? classes.inputList : classes.inputListEmpty
        }
      >
        {inputList.map((item, index) => selectionItem(item, index))}
        <div ref={scrollCheck}></div>
      </Box>
      <Divider className={classes.divider}></Divider>
    </Box>
  )
}

export default selectionComponent
